export default function ({ $config }) {
  // export default function () {
  window.dataLayer = window.dataLayer || []
  if ($config.NODE_ENV != 'production') {
    const domain =
      $config.NODE_ENV == 'production'
        ? 'https://st.digitl.net'
        : 'https://stage.st.digitl.net'
    ;(function (w, d, s, l) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s)
      j.async = true
      j.src = `${domain}/dtm.js`
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer')
  } else {
    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://sgtm.digitl.net/dtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', 'GTM-M6CKLTL')
  }
}
